<template>
    <div>
        <!-- CALENDAR -->
        <div class="vx-col w-full mt-4">
            <div id="simple-calendar-app">
                <div class="vx-card no-scroll-content">
                    <calendar-view
                    ref="calendar"
                    :displayPeriodUom="calendarView"
                    :show-date="showDate"
                    :events="simpleCalendarEvents"
                    enableDragDrop
                    :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
                    eventBorderHeight="0px"
                    eventContentHeight="1.65rem"
                    class="theme-default"
                    @click-date="openAddNewEvent"
                    @click-event="openEditEvent"
                    @drop-on-date="eventDragged"
                    >
                        <div slot="header" class="mb-4">
                            <div class="vx-row no-gutter">
                                <!-- Month Name -->
                                <div class="vx-col w-1/3 items-center sm:flex hidden">
                                    <!-- Add new event button -->
                                    <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">Nuevo evento</vs-button>
                                </div>
                                <!-- Current Month -->
                                <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
                                    <div class="flex items-center">
                                    <feather-icon
                                        :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                                        @click="updateMonth(-1)"
                                        svgClasses="w-5 h-5 m-1"
                                        class="cursor-pointer bg-primary text-white rounded-full" />
                                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month2 }}</span>
                                    <feather-icon
                                        :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                                        @click="updateMonth(1)"
                                        svgClasses="w-5 h-5 m-1"
                                        class="cursor-pointer bg-primary text-white rounded-full" />
                                    </div>
                                </div>
                                <div class="vx-col sm:w-1/3 w-full flex justify-center">
                                    <template v-for="(view, index) in calendarViewTypes">
                                    <vs-button
                                        v-if="calendarView === view.val"
                                        :key="String(view.val) + 'filled'"
                                        type="filled"
                                        class="p-3 md:px-8 md:py-3"
                                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                        @click="calendarView = view.val"
                                        >{{ view.label }}</vs-button>
                                    <vs-button
                                        v-else
                                        :key="String(view.val) + 'border'"
                                        type="border"
                                        class="p-3 md:px-8 md:py-3"
                                        :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                        @click="calendarView = view.val"
                                        >{{ view.label }}</vs-button>
                                    </template>
                                </div>
                            </div>
                            <div class="vx-row sm:flex hidden mt-4">
                                <div class="vx-col w-full flex">
                                    <!-- Labels -->
                                    <!-- <div class="flex flex-wrap sm:justify-start justify-center">
                                        <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                                            <span>{{ label.text }}</span>
                                        </div>
                                        <div class="flex items-center mr-4 mb-2">
                                            <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                                            <span>None</span>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </calendar-view>
                </div>
            </div>
      </div>
      
        <!-- ADD EVENT -->
        <vs-prompt
            class="calendar-event-dialog"
            title="Agregar Nuevo Evento"
            accept-text= "Agregar evento"
            cancel-text= "Cancelar"
            @accept="addEvent"
            :is-valid="validForm"
            :active.sync="activePromptAddEvent"
        >
            <!-- <div class="calendar__label-container flex">
                <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
                <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">
                    <feather-icon icon="DropletIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>
                    <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="labelLocal = 'none'">
                            <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                            <span>None</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div> -->
            <div class="vx-row">
                <div class="vx-col w-3/4">
                    <vs-input label="Nombre evento*" name="event-name" v-validate="'required'" class="w-full" v-model="title"></vs-input>
                </div>
                <div class="vx-col w-1/4">
                    <div class="calendar__label-container flex">
                        <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
                        <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">
                            <feather-icon icon="DropletIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>
                            <vs-dropdown-menu style="z-index: 200001">
                                <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                                    <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                                    <span>{{ label.text }}</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="labelLocal = 'none'">
                                    <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                                    <span>None</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full mt-2">
                    <label class="vs-input--label">Cliente</label>
                    <v-select :closeOnSelect="true" v-model="id_client" label="names_client" :options="clients" :reduce="clients => clients.id_client">
                        <template #option="{ names_client, surnames_client, email_user }">
                            <small>
                            <vs-list class="vs-list--subtitle p-0 m-0"> {{ names_client }} {{ surnames_client }} ({{ email_user }})</vs-list>
                            </small>
                        </template>
                        <template #selected-option="{ names_client, surnames_client, email_user }">
                            <small>
                            <span> {{ names_client }} {{ surnames_client }} ({{ email_user }})</span>
                            </small>
                        </template>
                        </v-select>
                </div>
            </div>
            <div class="vx-row my-2">
                <div class="vx-col w-1/2">
                    <small class="date-label">Fecha inicio*</small>
                    <datepicker :language="es" name="start-date" v-model="startDate" :disabled="disabledFrom"></datepicker>
                </div>
                <div class="vx-col w-1/2">
                    <small class="date-label">Fecha fin*</small>
                    <datepicker :language="es" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker>
                </div>
            </div>
        </vs-prompt>

      <!-- EDIT EVENT -->
        <vs-prompt
            class="calendar-event-dialog"
            title="Editar Evento"
            accept-text= "Ingresar"
            cancel-text = "Borrar evento"
            button-cancel = "border"
            @cancel="removeEvent"
            @accept="editEvent"
            :is-valid="validForm"
            :active.sync="activePromptEditEvent"
        >
            <div class="calendar__label-container flex">
                <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
                <vs-dropdown vs-custom-content class="ml-auto mt-1 cursor-pointer">
                    <feather-icon icon="DropletIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>
                    <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="labelLocal = 'none'">
                            <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                            <span>None</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
            <p v-if="this.full_name_employee">Asesor: {{this.full_name_employee}}</p>
            <p v-if="this.full_name_client">Cliente: {{this.full_name_client}}</p>
            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <vs-input label="Nombre evento*" name="event-name" v-validate="'required'" class="w-full" v-model="title"></vs-input>
                </div>
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Color</label>
                    <v-select :closeOnSelect="true" v-model="labelLocal" label="text" :options="calendarLabels" :reduce="calendarLabels => calendarLabels.value"></v-select>
                </div>
            </div>
            <div class="vx-row my-2">
                <div class="vx-col w-1/2">
                    <small class="date-label">Fecha inicio*</small>
                    <datepicker :language="es" :disabledDates="disabledDatesFrom" name="start-date" v-model="startDate"></datepicker>
                </div>
                <div class="vx-col w-1/2">
                    <small class="date-label">Fecha fin*</small>
                    <datepicker :language="es" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker>
                </div>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import CalendarView from '@/components/calendar/calendarEmployee/CalendarView.vue'
import CalendarViewHeader from '@/components/calendar/calendarEmployee/CalendarViewHeader.vue'
require('vue-simple-calendar/static/css/default.css')
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    'v-select': vSelect,
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  data () {
    return {
      //calendar
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      en,
      es,
      url: '',
      calendarView: 'month',
      id_client: null, 
      full_name_employee: null,
      full_name_client: null,

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: 'Mes',
          val: 'month'
        },
        {
          label: 'Semana',
          val: 'week'
        }
      ]
    }
  },
  computed: {
    // CALENDAR
    simpleCalendarEvents () {
      return this.$store.state.events
    },
    clients () {
      const clients = this.$store.state.clientsPDN
      return clients.sort((a, b) => b.id_client - a.id_client)
    },
    validForm () {
      return this.title !== '' && this.startDate !== '' && this.endDate !== '' && Date.parse(this.endDate) - Date.parse(this.startDate) >= 0 && !this.errors.has('event-url')
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return this.$store.state.eventLabels
    },
    labelColor () {
      return (label) => {
        if      (label === 'verde') return 'success'
        else if (label === 'naranja')     return 'warning'
        else if (label === 'rojo') return 'danger'
        else if (label === 'negro')     return 'dark'
        else if (label === 'gris')     return 'grey'
        else if (label === 'gris-claro')     return 'grey-light'
        else if (label === 'azul')     return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    // CALENDAR
    addEvent () {
      const obj = { 
        client_id: this.id_client,
        name: this.title,
        description: this.labelLocal, 
        start_date: `${new Date(this.startDate).getFullYear()}-${new Date(this.startDate).getMonth() + 1}-${new Date(this.startDate).getDate()}`,
        due_date: `${new Date(this.endDate).getFullYear()}-${new Date(this.endDate).getMonth() + 1}-${new Date(this.endDate).getDate()} 23:59:59`
      }
      obj.classes = `${this.labelLocal}`
      this.$store.dispatch('addEvent', obj)
        .then(() => {
          this.$store.dispatch('fetchEvents')
          this.id_client = null
          this.$vs.notify({
            title: 'Evento agregado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 2000
          })
        })
        .catch(err => console.log(err))
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = ''
      this.id = 0
      this.labelLocal = 'none'
    },
    promptAddNewEvent (date) {
      this.disabledFrom = false
      this.addNewEventDialog(date)
    },
    addNewEventDialog (date) {
      this.clearFields()
      this.startDate = date
      this.endDate = date
      this.activePromptAddEvent = true
    },
    openAddNewEvent (date) {
      this.disabledFrom = true
      this.addNewEventDialog(date)
    },
    openEditEvent (event) {
      const e = this.$store.getters['getEvent'](event.id)
      this.id = e.id_calendar
      this.title = e.name_calendar
      this.startDate = e.start_date_calendar
      this.endDate = e.due_date_calendar
      this.labelLocal = e.description_calendar
      this.id_client = e.id_client
      this.full_name_employee = e.full_name_employee
      this.full_name_client = e.full_name_client
      this.activePromptEditEvent = true
    },
    editEvent () {
      const obj = { 
        id: this.id, 
        client_id: this.id_client,
        name: this.title,
        description: this.labelLocal, 
        start_date: `${new Date(this.startDate).getFullYear()}-${new Date(this.startDate).getMonth() + 1}-${new Date(this.startDate).getDate()}`,
        due_date: `${new Date(this.endDate).getFullYear()}-${new Date(this.endDate).getMonth() + 1}-${new Date(this.endDate).getDate()} 00:01`
      }
      obj.classes = `${this.labelLocal}`
      this.$store.dispatch('editEvent', obj)
        .then(() => {
          this.$store.dispatch('fetchEvents')
          this.$vs.notify({
            title: 'Evento actualizado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 2000
          })
        })
        .catch(err => console.log(err))
    },
    removeEvent () {
      this.$store.dispatch('removeEvent', this.id)
        .then(() => {
          this.$store.dispatch('fetchEvents')
          this.$vs.notify({
            title: 'Evento borrado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 2000
          })
        })
        .catch(err => console.log(err))
    },
    eventDragged (event, date) {
      this.$store.dispatch('eventDragged', {event, date})
        .then(() => {
          this.$store.dispatch('fetchEvents')
          this.$vs.notify({
            title: 'Evento actualizado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 2000
          })
        })
        .catch(err => console.log(err))
    }
  },
  created () {
    const userData = JSON.parse((localStorage.getItem('userInfo')))
    this.$store.dispatch('fetchEventPerAsessor', userData.employee_id)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
